export default function Logo() {
  return (
    <a href="/" className="flex flex-row items-baseline">
      <span className="sr-only">company logo</span>
      <span className="text-3xl font-bold text-purple-900">🐈.xyz</span>
    </a>
  );
}
